import React from "react";
import LastPortClearance from "./LastPortClearance";
import Port from "./Port";
import SolasChapterIspsCode from "./SolasChapterIspsCode";
import VoyageDetails from "./VoyageDetails";

const TEST_ID_BASE = "pre-arrival-notification";

const PreArrivalNotification: React.FC = () => {
  return (
    <div className="min-w-full flex flex-col gap-8 pb-8" data-testid={TEST_ID_BASE}>
      <Port />
      <VoyageDetails />
      <SolasChapterIspsCode />
      <LastPortClearance />
    </div>
  );
};

export default PreArrivalNotification;
